import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { authSelectors } from '../../ducks/auth';
import { PageRoute } from '../../constants/routes';
import { LoadingIndicator } from './LoadingIndicator';

interface AuthGuardProps {
    children: React.ReactNode;
    redirectTo?: string;
}

export const AuthGuard: React.FC<AuthGuardProps> = ({
    children,
    redirectTo = PageRoute.LOGIN,
}) => {
    const isLoggedIn = useSelector(authSelectors.isLoggedIn);
    const loggedInUser = useSelector(authSelectors.loggedInUser);
    const isInitialized = useSelector(authSelectors.isInitialized);

    // Show loading while authentication is being initialized
    if (!isInitialized) {
        return <LoadingIndicator isShown={true} />;
    }

    // If not authenticated, redirect to login
    if (!isLoggedIn || !loggedInUser) {
        return <Navigate to={redirectTo} replace />;
    }

    // If authenticated, render the children
    return <>{children}</>;
};
